
import { defineComponent } from 'vue';
import { translate } from 'CoreHome';

export default defineComponent({
  props: {
    aiLabel: { type: String, required: true },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      prompt: '',
    };
  },
  computed: {
    submitText(): string {
      return translate('ChatGPT_Submit');
    },
    placeholderText(): string {
      return translate('ChatGPT_MessagePlaceholder', this.aiLabel);
    },
  },
  methods: {
    onSubmit() {
      if (!this.prompt.trim()) return;
      this.$emit('prompt', { role: 'user', content: this.prompt });
      this.prompt = '';
    },
  },
});
